import React from 'react';
import { willShowModal } from '../Common/Modal/Modal';
import { NavButton, NavCart } from './ViewComponents';
import Auth from '../Auth/index';
import { ShowIfAuthenticated, hideIfAuthenticated } from '../Auth/TokenManager';
import { forDesktopOnly } from '../Common/Helper';
import { hasAccountMenuData } from './NavData';
import { HTMLTrans, TransLink } from '../Common/Translations';

const NavAccount = (props) => {
  const { data = [], globalShippingCreditMenuItems } = props;
  return (
    <div className="dropdown nav__dropdown--border">
      <NavButton style={{ 'textDecorationLine': 'none' }} className="btn btn-link text-gray-darken-1 dropdown-toggle m-0" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <HTMLTrans id="navbar.navaccount_title">MY ACCOUNT</HTMLTrans>
      </NavButton>
      <div className="dropdown-menu navigation-dropdown-menu" aria-labelledby="dropdownMenuButton">

        <div className="dropdown-item-container">
          {globalShippingCreditMenuItems.map(item => (
            <TransLink
              key={item.id}
              url={item.url}
              name={item.label}
              id={item.id}
              className="dropdown-item ProximaNova"
            />
          ))}
        </div>

        <div className="dropdown-divider" />

        <div className="dropdown-item-container">
          {data.map(item => (
            <TransLink
              key={item.id}
              url={item.url}
              name={item.label}
              id={item.id}
              className="dropdown-item ProximaNova"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

const Button = ({ label = '' }) => (<NavButton>{label}</NavButton>);
const withModal = willShowModal({ size: 'md' });

export const LoginButtonStyle = () => (<Button label={<span id="loginLink"><HTMLTrans id="navbar.navaccount_login">LOGIN</HTMLTrans></span>}/>);
export const SignupButtonStyle = () => (<Button label={<span id="signupLink"><HTMLTrans id="navbar.navaccount_signup">SIGN UP</HTMLTrans></span>}/>);

export const hasLoginModal = (Comp) => {
  const Modal = withModal(Comp);
  return (props) => {
    return (
      <Modal>
        {closeModal => (
          <Auth
            closeModal={closeModal}
          />
        )}
      </Modal>
    );
  };
};

export const hasSignupModal = (Comp) => {
  const Modal = withModal(Comp);
  return (props) => {
    return (
      <Modal>
        {closeModal => (
          <Auth
            closeModal={closeModal} formState='register'/>
        )}
      </Modal>
    );
  };
};


export const NavCartAuthenticated = ShowIfAuthenticated(props => (
  <TransLink url='/checkout/cart'><NavCart {...props}/></TransLink>
));
export const NavCartUnauthenticated = hasLoginModal(hideIfAuthenticated(NavCart));
export const NavCartAuthenticatedMtyCart = ShowIfAuthenticated(NavCart);

export const MyAccount = forDesktopOnly(ShowIfAuthenticated(hasAccountMenuData(NavAccount)));
export const Login = forDesktopOnly(hideIfAuthenticated(hasLoginModal(LoginButtonStyle)));
export const Signup = forDesktopOnly(hideIfAuthenticated(hasSignupModal(SignupButtonStyle)));

export default NavAccount;
export const undecorated = NavAccount;



// WEBPACK FOOTER //
// ./src/Nav/NavAccount.js